import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faListCheck } from "@fortawesome/free-solid-svg-icons";
import { APISD } from "../../../../../../config/apisd";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

export default function DetailUlanganPage({
  selectedMatpel,
  selectedUlangan,
  setSelectedUlangan,
  selectedAcademicYearId,
  selectedSemesterId,
  getToken,
  getUserId,
  getBranchId,
  getSchoolId,
  ToastSuccess,
  ToastError,
}) {
  const [activeTab, setActiveTab] = useState("detailulangan");

  const [detailUlangan, setDetailUlangan] = useState(null);
  const [isFetchingDetail, setIsFetchingDetail] = useState(false);

  const [students, setStudents] = useState([]);
  const [selectedKelasId, setSelectedKelasId] = useState("");
  const [isFetchingScores, setIsFetchingScores] = useState(false);
  const [savingScoreId, setSavingScoreId] = useState(null);

  const [showSyncRemedial, setShowSyncRemedial] = useState(false);
  const [nilaiRows, setNilaiRows] = useState({});

  const lastSavedFingerprintRef = useRef({});
  const savingRowRef = useRef({});

  const safeStr = (v) => (v === null || v === undefined ? "" : String(v));

  const getAuthHeaders = () => ({
    Authorization: getToken?.(),
    "Content-Type": "application/json",
  });

  const handleBackToUlangan = () => {
    if (typeof setSelectedUlangan === "function") {
      setSelectedUlangan(null);
    }
  };

  const getExamId = () => {
    return selectedUlangan?.id || detailUlangan?.id || "";
  };

  const normalizeBool = (value) => {
    return (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true"
    );
  };

  const yesNo = (value) => {
    return normalizeBool(value) ? "Ya" : "Tidak";
  };

  const toTitleCase = (value) => {
    const s = safeStr(value).toLowerCase().trim();
    if (!s) return "";
    return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
  };

  const formatDate = (value, withTime = false) => {
    if (!value) return "-";

    const raw = safeStr(value);

    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
      const [year, month, day] = raw.split("-");
      const date = new Date(Number(year), Number(month) - 1, Number(day));

      return date.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }

    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return raw;

    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      ...(withTime
        ? {
            hour: "2-digit",
            minute: "2-digit",
          }
        : {}),
    });
  };

  const formatTime = (value) => {
    if (!value) return "";
    const raw = safeStr(value);
    if (/^\d{2}:\d{2}/.test(raw)) return raw.slice(0, 5);
    return raw;
  };

  const formatDateTimeExamByKelas = (kelas) => {
    const dateExam =
      kelas?.date_exam ||
      kelas?.tanggal_ujian ||
      kelas?.raw?.date_exam ||
      "";

    const timeExam =
      kelas?.time_exam ||
      kelas?.waktu_ujian ||
      kelas?.raw?.time_exam ||
      "";

    if (!dateExam && !timeExam) return "-";

    return `${formatDate(dateExam)}${timeExam ? `, ${formatTime(timeExam)}` : ""}`;
  };

  const getArrayFromResponse = (responseData) => {
    if (Array.isArray(responseData?.data?.data_murid)) return responseData.data.data_murid;
    if (Array.isArray(responseData?.data_murid)) return responseData.data_murid;
    if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
    if (Array.isArray(responseData?.data)) return responseData.data;
    if (Array.isArray(responseData?.result)) return responseData.result;
    if (Array.isArray(responseData)) return responseData;
    return [];
  };

  const getDetailDataFromResponse = (responseData) => {
    if (responseData?.data && !Array.isArray(responseData.data)) return responseData.data;
    return responseData || {};
  };

  const getDetailUlangan = async () => {
    const examId = selectedUlangan?.id;

    if (!examId) return;

    setIsFetchingDetail(true);

    try {
      const response = await APISD.get(`/api/matpels-exam/${examId}`, {
        headers: getAuthHeaders(),
      });

      setDetailUlangan(getDetailDataFromResponse(response?.data));
    } catch (error) {
      ToastError?.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil detail ulangan",
      });

      setDetailUlangan(null);
    } finally {
      setIsFetchingDetail(false);
    }
  };

  const kelasOptions = useMemo(() => {
    const fromDetailItems = Array.isArray(detailUlangan?.items)
      ? detailUlangan.items
      : [];

    const fromSelectedItems = Array.isArray(selectedUlangan?.items)
      ? selectedUlangan.items
      : Array.isArray(selectedUlangan?.kelas_list)
      ? selectedUlangan.kelas_list
      : Array.isArray(selectedUlangan?.raw?.items)
      ? selectedUlangan.raw.items
      : Array.isArray(selectedUlangan?.raw?.kelas_list)
      ? selectedUlangan.raw.kelas_list
      : [];

    const scheduleItems =
      fromDetailItems.length > 0 ? fromDetailItems : fromSelectedItems;

    if (scheduleItems.length > 0) {
      return scheduleItems
        .map((kelas, index) => ({
          id:
            kelas?.ysb_kelas_id ||
            kelas?.id ||
            kelas?.kelas_id ||
            `kelas-${index}`,
          name:
            kelas?.name_kelas ||
            kelas?.nama_kelas ||
            kelas?.kelas_name ||
            kelas?.name ||
            "Kelas",
          date_exam: kelas?.date_exam || "",
          time_exam: kelas?.time_exam || "",
          schedule_id: kelas?.schedule_id || "",
          raw: kelas,
        }))
        .filter((kelas) => kelas.id);
    }

    const fromMatpel = (selectedMatpel?.kelas_list || [])
      .map((kelas, index) => ({
        id: kelas?.ysb_kelas_id || kelas?.id || `kelas-${index}`,
        name:
          kelas?.nama_kelas ||
          kelas?.name_kelas ||
          kelas?.kelas_name ||
          kelas?.name ||
          "Kelas",
        date_exam: kelas?.date_exam || "",
        time_exam: kelas?.time_exam || "",
        schedule_id: kelas?.schedule_id || "",
        raw: kelas,
      }))
      .filter((kelas) => kelas.id);

    return fromMatpel;
  }, [detailUlangan, selectedMatpel, selectedUlangan]);

  const activeKelasName = useMemo(() => {
    const found = kelasOptions.find(
      (kelas) => String(kelas.id) === String(selectedKelasId)
    );

    return found?.name || "-";
  }, [kelasOptions, selectedKelasId]);

  const getSelectedAssignment = () => {
    const kelasList = Array.isArray(selectedMatpel?.kelas_list)
      ? selectedMatpel.kelas_list
      : [];

    return (
      kelasList.find(
        (kelas) => String(kelas?.ysb_kelas_id) === String(selectedKelasId)
      ) ||
      kelasList.find(
        (kelas) =>
          String(kelas?.ysb_kelas_id) ===
          String(detailUlangan?.ysb_kelas_id || selectedUlangan?.ysb_kelas_id)
      ) ||
      {}
    );
  };

  const getBranchIdValue = () => {
    const assignment = getSelectedAssignment();

    return (
      assignment?.ysb_branch_id ||
      assignment?.raw?.assignment?.ysb_branch_id ||
      assignment?.raw?.kelas?.ysb_branch_id ||
      detailUlangan?.ysb_branch_id ||
      selectedUlangan?.ysb_branch_id ||
      selectedUlangan?.raw?.ysb_branch_id ||
      getBranchId?.() ||
      localStorage.getItem("ysb_branch_id") ||
      localStorage.getItem("branchID") ||
      ""
    );
  };

  const getSchoolIdValue = () => {
    const assignment = getSelectedAssignment();

    return (
      assignment?.ysb_school_id ||
      assignment?.raw?.assignment?.ysb_school_id ||
      assignment?.raw?.kelas?.ysb_school_id ||
      detailUlangan?.ysb_school_id ||
      selectedUlangan?.ysb_school_id ||
      selectedUlangan?.raw?.ysb_school_id ||
      getSchoolId?.() ||
      localStorage.getItem("ysb_school_id") ||
      localStorage.getItem("schoolID") ||
      ""
    );
  };

  const getAcademicYearIdValue = () => {
    return (
      detailUlangan?.ysb_academic_year_id ||
      selectedAcademicYearId ||
      selectedUlangan?.ysb_academic_year_id ||
      selectedUlangan?.raw?.ysb_academic_year_id ||
      ""
    );
  };

  const getSemesterIdValue = () => {
    return (
      detailUlangan?.ysb_semester_id ||
      selectedSemesterId ||
      selectedUlangan?.ysb_semester_id ||
      selectedUlangan?.raw?.ysb_semester_id ||
      ""
    );
  };

  const getGradeLevelIdValue = () => {
    return (
      detailUlangan?.ysb_grade_level_id ||
      selectedMatpel?.ysb_grade_level_id ||
      selectedUlangan?.ysb_grade_level_id ||
      selectedUlangan?.raw?.ysb_grade_level_id ||
      ""
    );
  };

  const getMatpelIdValue = () => {
    return (
      detailUlangan?.ysb_matpel_id ||
      selectedMatpel?.ysb_matpel_id ||
      selectedMatpel?.id ||
      selectedUlangan?.ysb_matpel_id ||
      selectedUlangan?.raw?.ysb_matpel_id ||
      ""
    );
  };

  const getTeacherIdValue = () => {
    return (
      localStorage.getItem("teacherID") ||
      selectedUlangan?.ysb_teacher_id ||
      selectedUlangan?.raw?.ysb_teacher_id ||
      getUserId?.() ||
      ""
    );
  };

  const selectedCp = useMemo(() => {
    const cpList =
      detailUlangan?.cp_terpilih ||
      detailUlangan?.informasi_ujian?.cp_terpilih ||
      [];

    return Array.isArray(cpList) && cpList.length > 0 ? cpList[0] : null;
  }, [detailUlangan]);

  const selectedTpList = useMemo(() => {
    const fromDetail =
      detailUlangan?.tp_terpilih ||
      detailUlangan?.informasi_ujian?.tp_terpilih ||
      [];

    const fromSelected =
      selectedUlangan?.tp_terpilih ||
      selectedUlangan?.raw?.tp_terpilih ||
      [];

    if (Array.isArray(fromDetail) && fromDetail.length > 0) {
      return fromDetail
        .map((tp, index) => ({
          id:
            tp?.id ||
            tp?.ysb_matpel_tp_id ||
            tp?.matpel_tp_id ||
            `tp-${index}`,
          name_tp:
            tp?.name_tp ||
            tp?.tp ||
            tp?.nama_tp ||
            `TP ${index + 1}`,
          name_information:
            tp?.name_information ||
            tp?.keterangan ||
            tp?.description ||
            "",
          raw: tp,
        }))
        .filter((tp) => tp.id);
    }

    if (Array.isArray(fromSelected) && fromSelected.length > 0) {
      return fromSelected
        .map((tp, index) => ({
          id:
            tp?.id ||
            tp?.ysb_matpel_tp_id ||
            tp?.matpel_tp_id ||
            `tp-${index}`,
          name_tp:
            tp?.name_tp ||
            tp?.tp ||
            tp?.nama_tp ||
            `TP ${index + 1}`,
          name_information:
            tp?.name_information ||
            tp?.keterangan ||
            tp?.description ||
            "",
          raw: tp,
        }))
        .filter((tp) => tp.id);
    }

    if (Array.isArray(selectedUlangan?.tp_list) && selectedUlangan.tp_list.length > 0) {
      return selectedUlangan.tp_list
        .map((tp, index) => ({
          id:
            tp?.ysb_matpel_tp_id ||
            tp?.id ||
            `tp-${index}`,
          name_tp:
            tp?.name_tp ||
            tp?.tp ||
            tp?.nama_tp ||
            `TP ${index + 1}`,
          name_information:
            tp?.name_information ||
            tp?.keterangan ||
            "",
          raw: tp,
        }))
        .filter((tp) => tp.id);
    }

    if (selectedUlangan?.ysb_matpel_tp_id) {
      return [
        {
          id: selectedUlangan.ysb_matpel_tp_id,
          name_tp: selectedUlangan?.tp_name || "TP",
          name_information: "",
          raw: selectedUlangan,
        },
      ];
    }

    return [];
  }, [detailUlangan, selectedUlangan]);

  const cpName =
    detailUlangan?.cp_terpilih ||
    "Nama CP";

  const tpName =
    selectedTpList.length > 0
      ? selectedTpList
          .map((tp) => tp?.name_tp || "-")
          .filter(Boolean)
          .join(", ")
      : "NamaTP";

  const typeName =
    detailUlangan?.name_learning ||
    "-";

  const notificationValue =
    detailUlangan?.notifikasi ??
    0;

  const discussValue =
    detailUlangan?.diskusi ??
    0;

  const hideExamValue =
    detailUlangan?.sembunyikan_soal_ujian ??
    0;

  const hideExamScoreValue =
    detailUlangan?.sembunyikan_nilai_ujian ??
    0;

  const normalizeStatusRemed = (value) => {
    if (value === true || value === 1 || value === "1" || value === "true") {
      return true;
    }

    if (value === false || value === 0 || value === "0" || value === "false") {
      return false;
    }

    return null;
  };

  const getRemedialLabel = (status) => {
    if (status === true) return "IYA";
    if (status === false) return "TIDAK";
    return "";
  };

  const normalizeScoreRows = (rows = []) => {
    return rows.map((item, index) => {
      const dataNilai = Array.isArray(item?.data_nilai) ? item.data_nilai : [];

      const studentId =
        item?.ysb_student_id ||
        item?.student_id ||
        item?.id ||
        `student-${index}`;

      const nilaiByTp = {};

      selectedTpList.forEach((tp, tpIndex) => {
        const nilai =
          dataNilai.find(
            (row) => String(row?.ysb_matpel_tp_id) === String(tp.id)
          ) ||
          dataNilai[tpIndex] ||
          dataNilai[0] ||
          {};

        const statusRemed = normalizeStatusRemed(nilai?.status_remed);

        nilaiByTp[tp.id] = {
          score_id: nilai?.id || "default",
          ysb_matpel_tp_id: tp.id,
          nilai:
            nilai?.score !== null && nilai?.score !== undefined
              ? nilai.score
              : "",
          komentar: nilai?.comment || "",
          status_remed: statusRemed,
          remedial: getRemedialLabel(statusRemed),
        };
      });

      return {
        id: studentId,
        ysb_student_id: studentId,
        name:
          item?.nama_lengkap ||
          item?.nama_siswa ||
          item?.name ||
          "-",
        nilai_by_tp: nilaiByTp,
        raw: item,
      };
    });
  };

  const getExamScores = async () => {
    const examId = getExamId();
    const kelasId = selectedKelasId || kelasOptions?.[0]?.id || "";

    if (!examId || !kelasId) return;

    setIsFetchingScores(true);

    try {
      const payload = {
        ysb_matpels_exam_id: examId,
        ysb_kelas_id: kelasId,
        ysb_branch_id: getBranchIdValue(),
        ysb_school_id: getSchoolIdValue(),
      };

      if (!payload.ysb_branch_id || !payload.ysb_school_id) {
        ToastError?.fire({
          icon: "error",
          title: "Branch ID atau School ID tidak ditemukan dari assignment kelas",
        });

        setStudents([]);
        setNilaiRows({});
        setIsFetchingScores(false);
        return;
      }

      const response = await APISD.request({
        method: "GET",
        url: "/api/exam-scores",
        headers: getAuthHeaders(),
        params: payload,
      });

      const responseData = response?.data?.data || response?.data || {};
      const rows = normalizeScoreRows(getArrayFromResponse(response?.data));

      setStudents(rows);

      const nextNilaiRows = {};

      rows.forEach((student) => {
        nextNilaiRows[student.id] = student.nilai_by_tp || {};
      });

      setNilaiRows(nextNilaiRows);

      const nextSavedFingerprint = {};

      Object.keys(nextNilaiRows).forEach((studentId) => {
        Object.keys(nextNilaiRows[studentId] || {}).forEach((tpId) => {
          const key = `${studentId}-${tpId}`;
          nextSavedFingerprint[key] = getRowFingerprint(nextNilaiRows[studentId][tpId]);
        });
      });

      lastSavedFingerprintRef.current = nextSavedFingerprint;

      if (responseData?.informasi_ujian && !detailUlangan) {
        setDetailUlangan(responseData?.informasi_ujian);
      }
    } catch (error) {
      ToastError?.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal mengambil data nilai",
      });

      setStudents([]);
      setNilaiRows({});
    } finally {
      setIsFetchingScores(false);
    }
  };

  useEffect(() => {
    if (selectedUlangan?.id) {
      getDetailUlangan();
    }
  }, [selectedUlangan?.id]);

  useEffect(() => {
    if (kelasOptions.length > 0 && !selectedKelasId) {
      setSelectedKelasId(kelasOptions[0].id);
    }
  }, [kelasOptions, selectedKelasId]);

  useEffect(() => {
    if (activeTab === "inputnilai" && selectedKelasId && getExamId()) {
      getExamScores();
    }
  }, [
    activeTab,
    selectedKelasId,
    detailUlangan?.id,
    selectedUlangan?.id,
    selectedTpList.length,
  ]);

  const getRowFingerprint = (row = {}) => {
    return JSON.stringify({
      nilai: safeStr(row.nilai),
      remedial: safeStr(row.remedial),
      komentar: safeStr(row.komentar),
    });
  };

  const handleAutoSaveScore = async (student, tp) => {
    const row = nilaiRows?.[student.id]?.[tp.id] || {};
    const key = `${student.id}-${tp.id}`;
    const currentFingerprint = getRowFingerprint(row);

    if (lastSavedFingerprintRef.current?.[key] === currentFingerprint) {
      return;
    }

    if (savingRowRef.current?.[key]) {
      return;
    }

    await handleSaveScore(student, tp);
  };

  const handleInputKeyDown = async (e, student, tp) => {
    if (e.key === "Enter" || e.key === "Tab") {
      await handleAutoSaveScore(student, tp);
    }
  };

  const handleChangeNilai = (studentId, tpId, field, value) => {
    setNilaiRows((prev) => ({
      ...prev,
      [studentId]: {
        ...(prev?.[studentId] || {}),
        [tpId]: {
          ...(prev?.[studentId]?.[tpId] || {
            score_id: "default",
            ysb_matpel_tp_id: tpId,
            nilai: "",
            komentar: "",
            status_remed: null,
            remedial: "",
          }),
          [field]: value,
        },
      },
    }));
  };

  const totalTargetNilai = useMemo(() => {
    return students.length * Math.max(selectedTpList.length, 1);
  }, [students, selectedTpList]);

  const totalDinilai = useMemo(() => {
    let total = 0;

    students.forEach((student) => {
      selectedTpList.forEach((tp) => {
        const nilai = nilaiRows?.[student.id]?.[tp.id]?.nilai;

        if (nilai !== "" && nilai !== null && nilai !== undefined) {
          total += 1;
        }
      });
    });

    return total;
  }, [students, nilaiRows, selectedTpList]);

  const totalRemedial = useMemo(() => {
    let total = 0;

    students.forEach((student) => {
      selectedTpList.forEach((tp) => {
        if (nilaiRows?.[student.id]?.[tp.id]?.status_remed === true) {
          total += 1;
        }
      });
    });

    return total;
  }, [students, nilaiRows, selectedTpList]);

  const rerataNilai = useMemo(() => {
    const values = [];

    students.forEach((student) => {
      selectedTpList.forEach((tp) => {
        const nilai = Number(nilaiRows?.[student.id]?.[tp.id]?.nilai);

        if (!Number.isNaN(nilai)) {
          values.push(nilai);
        }
      });
    });

    if (values.length === 0) return "0";

    const total = values.reduce((sum, nilai) => sum + nilai, 0);
    return (total / values.length).toFixed(1);
  }, [students, nilaiRows, selectedTpList]);

  const handleSaveScore = async (student, tp) => {
    const row = nilaiRows?.[student.id]?.[tp.id] || {};

    if (row.nilai === "" || row.nilai === null || row.nilai === undefined) {
      ToastError?.fire({
        icon: "error",
        title: "Nilai wajib diisi",
      });
      return;
    }

    const scoreId = row.score_id || "default";
    const key = `${student.id}-${tp.id}`;
    const currentFingerprint = getRowFingerprint(row);

    if (lastSavedFingerprintRef.current?.[key] === currentFingerprint) {
      return;
    }

    savingRowRef.current[key] = true;
    setSavingScoreId(key);

    try {
      const payload = {
        ysb_academic_year_id: getAcademicYearIdValue(),
        ysb_semester_id: getSemesterIdValue(),
        ysb_branch_id: getBranchIdValue(),
        ysb_school_id: getSchoolIdValue(),
        ysb_grade_level_id: getGradeLevelIdValue(),
        ysb_matpel_id: getMatpelIdValue(),
        ysb_kelas_id: selectedKelasId,
        ysb_matpels_exam_id: getExamId(),
        ysb_student_id: student.ysb_student_id || student.id,
        ysb_matpel_tp_id: tp.id,
        ysb_teacher_id: getTeacherIdValue(),
        score: Number(row.nilai),
        comment: row.komentar || "",
        update_by: getUserId?.() || localStorage.getItem("userID") || "",
      };

      const response = await APISD.put(`/api/exam-scores/${scoreId}`, payload, {
        headers: getAuthHeaders(),
      });

      const responseData = response?.data?.data || response?.data || {};
      const nextStatusRemed = normalizeStatusRemed(responseData?.status_remed);

      lastSavedFingerprintRef.current[key] = currentFingerprint;

      setNilaiRows((prev) => ({
        ...prev,
        [student.id]: {
          ...(prev?.[student.id] || {}),
          [tp.id]: {
            ...(prev?.[student.id]?.[tp.id] || {}),
            score_id: responseData?.id || response?.data?.id || scoreId,
            status_remed: nextStatusRemed,
            remedial: getRemedialLabel(nextStatusRemed),
          },
        },
      }));

      ToastSuccess?.fire({
        icon: "success",
        title: response?.data?.message || "Nilai berhasil disimpan",
      });

      setShowSyncRemedial(true);
    } catch (error) {
      ToastError?.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal menyimpan nilai",
      });
    } finally {
      savingRowRef.current[key] = false;
      setSavingScoreId(null);
    }
  };

  const detailTitle =
    detailUlangan?.title ||
    detailUlangan?.judul_ujian ||
    selectedUlangan?.title ||
    "Judul Ulangan";

  const matpelName =
    detailUlangan?.name_matpel ||
    selectedMatpel?.nama_matpel ||
    selectedMatpel?.name_matpel ||
    selectedMatpel?.matpel_name ||
    "-";

  const StatusPill = ({ label, type = "default" }) => {
    const bgColor =
      type === "success"
        ? "#dcfce7"
        : type === "danger"
        ? "#fee2e2"
        : type === "warning"
        ? "#fef3c7"
        : type === "primary"
        ? "#dbeafe"
        : "#f3f4f6";

    const textColor =
      type === "success"
        ? "#15803d"
        : type === "danger"
        ? "#dc2626"
        : type === "warning"
        ? "#b45309"
        : type === "primary"
        ? "#2563eb"
        : "#4b5563";

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          borderRadius: 999,
          padding: "6px 12px",
          background: bgColor,
          color: textColor,
          fontSize: 13,
          fontWeight: 700,
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    );
  };

  const DetailInfoCard = ({ label, value, children }) => {
    return (
      <div className="exam-info-card">
        <div className="exam-info-label">{label}</div>
        <div className="exam-info-value">{children || value}</div>
      </div>
    );
  };

  const MiniSummaryCard = ({ label, value, type }) => {
    return (
      <div className="exam-mini-card">
        <div className="exam-mini-label">{label}</div>
        <div className="exam-mini-value">
          <StatusPill label={value} type={type} />
        </div>
      </div>
    );
  };

  return (
    <div className="body">
      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faListCheck} />
            </span>

            <div>
              <h4 className="page-title-text mb-0">Ulangan</h4>
            </div>
          </div>

          <div className="ml-auto">
            <button
              type="button"
              className="btn btn-light"
              onClick={handleBackToUlangan}
              style={{
                borderRadius: 12,
                padding: "8px 14px",
                fontWeight: 600,
              }}
            >
              <FontAwesomeIcon icon={faArrowLeft} /> Kembali
            </button>
          </div>
        </div>

        <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
          <ol className="custom-breadcrumb">
            <li className="custom-breadcrumb-item">
              <Link to="#" onClick={handleBackToUlangan}>
                Ulangan
              </Link>
            </li>
            <li className="custom-breadcrumb-separator">/</li>
            <li className="custom-breadcrumb-item active" aria-current="page">
              {detailTitle}
            </li>
          </ol>
        </nav>
      </div>

      <div className="body-content">
        <Tabs
          activeKey={activeTab}
          onSelect={(key) => setActiveTab(key)}
          id="tab-detail-ulangan"
          className="mb-3 nav-tabs"
        >
          <Tab eventKey="detailulangan" title="Detail Ulangan">
            <div className="exam-detail-wrapper">
              {isFetchingDetail ? (
                <div className="exam-loading-card">
                  Mengambil detail ulangan...
                </div>
              ) : (
                <>
                  <div className="exam-hero-card">
                    <div className="exam-hero-left">
                      <h3 className="exam-hero-title">{detailTitle}</h3>

                      <div className="exam-hero-meta">
                        <span>{matpelName}</span>
                        <span>•</span>
                        <span>{typeName || "-"}</span>
                      </div>
                    </div>

                    <div className="exam-hero-right">
                      {normalizeBool(notificationValue) ? (
                        <>
                          <StatusPill label="Sudah Diumumkan" type="success" />
                          <div className="exam-announce-date">
                            {formatDate(
                              detailUlangan?.updated_at ||
                                detailUlangan?.date_create_exam ||
                                selectedUlangan?.updated_at ||
                                new Date(),
                              true
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <StatusPill label="Belum Diumumkan" type="danger" />
                          <div className="exam-announce-date">
                            Ulangan belum dikirim ke siswa
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                  <div className="exam-summary-grid">
                    <MiniSummaryCard
                      label="Kumpul Online"
                      value="Tidak"
                      type="danger"
                    />

                    <MiniSummaryCard
                      label="Kirim Notifikasi"
                      value={yesNo(notificationValue)}
                      type={normalizeBool(notificationValue) ? "success" : "danger"}
                    />

                    <MiniSummaryCard
                      label="Diskusi"
                      value={normalizeBool(discussValue) ? "Dibuka" : "Ditutup"}
                      type={normalizeBool(discussValue) ? "success" : "danger"}
                    />

                    <MiniSummaryCard
                      label="Tersembunyi"
                      value={yesNo(hideExamValue)}
                      type={normalizeBool(hideExamValue) ? "warning" : "primary"}
                    />

                    <MiniSummaryCard
                      label="Sembunyikan Nilai"
                      value={yesNo(hideExamScoreValue)}
                      type={normalizeBool(hideExamScoreValue) ? "warning" : "primary"}
                    />

                    <MiniSummaryCard
                      label="Jenis Ulangan"
                      value={typeName || "-"}
                      type="primary"
                    />
                  </div>

                  <div className="exam-content-grid mt-3">
                    <div className="exam-main-panel">
                      <div className="exam-section-title">
                        Informasi Pembelajaran
                      </div>

                      <div className="exam-info-grid">
                        <DetailInfoCard label="TP Terpilih">
                          <div className="exam-tp-list">
                            {selectedTpList.length > 0 ? (
                              selectedTpList.map((tp) => (
                                <div className="exam-tp-item" key={tp.id}>
                                  <span className="exam-blue-text">
                                    {tp.name_tp || "-"}
                                  </span>

                                  {tp.name_information ? (
                                    <div className="exam-muted-text mt-1">
                                      {tp.name_information}
                                    </div>
                                  ) : null}
                                </div>
                              ))
                            ) : (
                              <span className="exam-muted-text">TP belum tersedia</span>
                            )}
                          </div>
                        </DetailInfoCard>

                        <DetailInfoCard label="Rerata Nilai CP">
                          <div>
                            <span className="exam-blue-text">{cpName}</span>{" "}
                            <span className="exam-green-text">
                              {rerataNilai} ({totalDinilai}/{totalTargetNilai || 0})
                            </span>
                          </div>
                        </DetailInfoCard>

                        <DetailInfoCard label="Rerata Nilai TP">
                          <div>
                            <span className="exam-blue-text">{tpName}</span>{" "}
                            <span className="exam-green-text">
                              {rerataNilai} ({totalDinilai}/{totalTargetNilai || 0})
                            </span>
                          </div>
                        </DetailInfoCard>
                      </div>
                    </div>
                  </div>

                  <div className="exam-schedule-panel">
                    <div className="exam-section-title">Tanggal Ulangan</div>

                    <div className="exam-class-grid">
                      {kelasOptions.length > 0 ? (
                        kelasOptions.map((kelas) => {
                          const dateText = formatDateTimeExamByKelas(kelas);

                          return (
                            <div className="exam-class-card" key={kelas.id}>
                              <div className="exam-class-name">
                                {toTitleCase(kelas.name)}
                              </div>

                              <div className="exam-class-date">
                                {dateText === "-" ? "Belum ada tanggal" : dateText}
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="exam-class-card">
                          <div className="exam-class-name">Kelas</div>
                          <div className="exam-class-date">Belum ada tanggal</div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </Tab>

          <Tab eventKey="inputnilai" title="Input Nilai">
            <div
              style={{
                background: "#fff",
                borderRadius: 6,
                padding: "15px",
              }}
            >
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="detail-label">KELAS</div>
                  <select
                    className="form-control"
                    value={selectedKelasId}
                    onChange={(e) => {
                      setSelectedKelasId(e.target.value);
                      setShowSyncRemedial(false);
                    }}
                    style={{ height: 35, fontSize: "14px" }}
                  >
                    {kelasOptions.map((kelas) => (
                      <option key={kelas.id} value={kelas.id}>
                        {toTitleCase(kelas.name)}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-6 mb-4">
                  <div className="detail-label">BATAL MENGUMUMKAN NILAI</div>
                  <button
                    type="button"
                    className="btn w-100"
                    style={{
                      height: 35,
                      borderRadius: 6,
                      background: "#f9a34b",
                      color: "#fff",
                      fontSize: "14px",
                    }}
                  >
                    Batal Mengumumkan Nilai
                  </button>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">KELAS TERPILIH</div>
                  <div className="detail-value text-primary">
                    {toTitleCase(activeKelasName)}
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">SUDAH DINILAI</div>
                  <div className="detail-value text-success">
                    {totalDinilai}/{totalTargetNilai || 0}
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">NILAI REMEDIAL</div>
                  <div className="detail-value text-success">
                    {totalRemedial}/{totalTargetNilai || 0}
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">STATUS</div>
                  <div className="detail-value text-success">
                    {normalizeBool(hideExamScoreValue)
                      ? "Nilai belum Diumumkan"
                      : "Nilai telah Diumumkan"}
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">TIPE ULANGAN</div>
                  <div className="detail-value text-primary">
                    {typeName}
                  </div>
                </div>

                <div className="col-md-9 mb-4">
                  <div className="detail-label">TP TERPILIH</div>
                  <div className="detail-value">
                    <span className="text-primary">{tpName}</span>
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">RERATA NILAI CP</div>
                  <div className="detail-value">
                    <span className="text-primary">{cpName}</span>{" "}
                    <span style={{ color: "#00a86b" }}>
                      {rerataNilai} ({totalDinilai}/{totalTargetNilai || 0})
                    </span>
                  </div>
                </div>

                <div className="col-md-3 mb-4">
                  <div className="detail-label">RERATA NILAI TP</div>
                  <div className="detail-value">
                    <span className="text-primary">{tpName}</span>{" "}
                    <span style={{ color: "#00a86b" }}>
                      {rerataNilai} ({totalDinilai}/{totalTargetNilai || 0})
                    </span>
                  </div>
                </div>
              </div>

              <div
                className="d-flex align-items-center justify-content-between mb-2"
                style={{ gap: 10 }}
              >
                <div className="detail-label mb-0">NILAI ULANGAN</div>

                {showSyncRemedial && (
                  <button
                    type="button"
                    className="btn btn-sm"
                    disabled={isFetchingScores}
                    onClick={async () => {
                      await getExamScores();
                      setShowSyncRemedial(false);
                    }}
                    style={{
                      borderRadius: 6,
                      background: "#006fb2",
                      color: "#fff",
                      fontSize: "13px",
                      fontWeight: 600,
                      padding: "7px 12px",
                    }}
                  >
                    {isFetchingScores ? "Menyinkronkan..." : "Sync Remedial"}
                  </button>
                )}
              </div>

              {/* <Col xl="12" sm="12">
                <div className="mt-3 body-table exam-score-table-wrap">
                  <table
                    className="table table-hover table-border-style"
                    id="basic-datatable"
                  >
                    <thead>
                      <tr>
                        <th style={{ width: 55 }}>No</th>
                        <th style={{ minWidth: 180 }}>Nama</th>

                        {selectedTpList.length > 0 ? (
                          selectedTpList.map((tp) => (
                            <th
                              key={tp.id}
                              colSpan="3"
                              style={{
                                textAlign: "center",
                                minWidth: 430,
                              }}
                            >
                              {tp.name_tp}
                            </th>
                          ))
                        ) : (
                          <th style={{ textAlign: "center" }}>Nilai</th>
                        )}
                      </tr>

                      {selectedTpList.length > 0 && (
                        <tr>
                          <th></th>
                          <th></th>

                          {selectedTpList.map((tp) => (
                            <template key={`sub-${tp.id}`}>
                              <th style={{ width: 120, textAlign: "center" }}>
                                Nilai
                              </th>
                              <th style={{ width: 130, textAlign: "center" }}>
                                Remedial
                              </th>
                              <th style={{ minWidth: 180, textAlign: "center" }}>
                                Komentar
                              </th>
                            </template>
                          ))}
                        </tr>
                      )}
                    </thead>

                    <tbody>
                      {isFetchingScores ? (
                        <tr>
                          <td
                            colSpan={
                              selectedTpList.length > 0
                                ? 2 + selectedTpList.length * 3
                                : 3
                            }
                            className="text-center p-4"
                          >
                            Mengambil data nilai...
                          </td>
                        </tr>
                      ) : students.length > 0 && selectedTpList.length > 0 ? (
                        students.map((student, index) => (
                          <tr
                            key={student.id}
                            style={{
                              background: index % 2 === 0 ? "#f7fafe" : "#fff",
                            }}
                          >
                            <td
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                            >
                              {index + 1}
                            </td>

                            <td style={{ verticalAlign: "middle" }}>
                              {student.name}
                            </td>

                            {selectedTpList.map((tp) => {
                              const row = nilaiRows?.[student.id]?.[tp.id] || {};
                              const savingKey = `${student.id}-${tp.id}`;

                              return (
                                <template key={`${student.id}-${tp.id}`}>
                                  <td style={{ verticalAlign: "middle" }}>
                                    <input
                                      type="number"
                                      className="form-control text-center"
                                      value={row?.nilai ?? ""}
                                      disabled={savingScoreId === savingKey}
                                      onChange={(e) =>
                                        handleChangeNilai(
                                          student.id,
                                          tp.id,
                                          "nilai",
                                          e.target.value
                                        )
                                      }
                                      onBlur={() => handleAutoSaveScore(student, tp)}
                                      onKeyDown={(e) =>
                                        handleInputKeyDown(e, student, tp)
                                      }
                                      style={{
                                        color: "#00a86b",
                                        fontWeight: 700,
                                        fontSize: "13px",
                                      }}
                                    />
                                  </td>

                                  <td style={{ verticalAlign: "middle" }}>
                                    <input
                                      type="text"
                                      className="form-control text-center"
                                      value={getRemedialLabel(row?.status_remed)}
                                      disabled
                                      readOnly
                                      style={{
                                        background:
                                          row?.status_remed === true
                                            ? "#fee2e2"
                                            : "#f3f4f6",
                                        color:
                                          row?.status_remed === true
                                            ? "#dc2626"
                                            : "#6b7280",
                                        border:
                                          row?.status_remed === true
                                            ? "1px solid #fca5a5"
                                            : "1px solid #d1d5db",
                                        fontWeight: 700,
                                        fontSize: "13px",
                                        cursor: "not-allowed",
                                      }}
                                    />
                                  </td>

                                  <td style={{ verticalAlign: "middle" }}>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={row?.komentar || ""}
                                      disabled={savingScoreId === savingKey}
                                      onChange={(e) =>
                                        handleChangeNilai(
                                          student.id,
                                          tp.id,
                                          "komentar",
                                          e.target.value
                                        )
                                      }
                                      onBlur={() => handleAutoSaveScore(student, tp)}
                                      onKeyDown={(e) =>
                                        handleInputKeyDown(e, student, tp)
                                      }
                                      style={{
                                        fontSize: "13px",
                                      }}
                                    />
                                  </td>
                                </template>
                              );
                            })}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={
                              selectedTpList.length > 0
                                ? 2 + selectedTpList.length * 3
                                : 3
                            }
                            className="text-center p-4"
                          >
                            {selectedTpList.length === 0
                              ? "TP belum tersedia"
                              : "Data murid belum tersedia"}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col> */}

              <Col xl="12" sm="12">
  <div className="mt-3 body-table exam-score-table-wrap">
    <table
      className="table table-hover table-border-style"
      id="basic-datatable"
    >
      <thead>
        <tr>
          <th rowSpan="2" style={{ width: 55, textAlign: "center" }}>
            No
          </th>

          <th rowSpan="2" style={{ minWidth: 220 }}>
            Nama
          </th>

          {selectedTpList.length > 0 ? (
            selectedTpList.map((tp) => (
              <th
                key={tp.id}
                colSpan="3"
                style={{
                  textAlign: "center",
                  minWidth: 420,
                }}
              >
                {tp.name_tp}
              </th>
            ))
          ) : (
            <th style={{ textAlign: "center" }}>Nilai</th>
          )}
        </tr>

        {selectedTpList.length > 0 && (
          <tr>
            {selectedTpList.map((tp) => (
              <React.Fragment key={`head-${tp.id}`}>
                <th style={{ width: 120, textAlign: "center" }}>
                  Nilai
                </th>

                <th style={{ width: 130, textAlign: "center" }}>
                  Remedial
                </th>

                <th style={{ minWidth: 180, textAlign: "center" }}>
                  Komentar Guru
                </th>
              </React.Fragment>
            ))}
          </tr>
        )}
      </thead>

      <tbody>
        {isFetchingScores ? (
          <tr>
            <td
              colSpan={
                selectedTpList.length > 0
                  ? 2 + selectedTpList.length * 3
                  : 3
              }
              className="text-center p-4"
            >
              Mengambil data nilai...
            </td>
          </tr>
        ) : students.length > 0 && selectedTpList.length > 0 ? (
          students.map((student, index) => (
            <tr
              key={student.id}
              style={{
                background: index % 2 === 0 ? "#f7fafe" : "#fff",
              }}
            >
              <td
                style={{
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {index + 1}
              </td>

              <td style={{ verticalAlign: "middle" }}>
                {student.name}
              </td>

              {selectedTpList.map((tp) => {
                const row = nilaiRows?.[student.id]?.[tp.id] || {};
                const savingKey = `${student.id}-${tp.id}`;

                return (
                  <React.Fragment key={`${student.id}-${tp.id}`}>
                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        type="number"
                        className="form-control text-center"
                        value={row?.nilai ?? ""}
                        disabled={savingScoreId === savingKey}
                        onChange={(e) =>
                          handleChangeNilai(
                            student.id,
                            tp.id,
                            "nilai",
                            e.target.value
                          )
                        }
                        onBlur={() => handleAutoSaveScore(student, tp)}
                        onKeyDown={(e) =>
                          handleInputKeyDown(e, student, tp)
                        }
                        style={{
                          color: "#00a86b",
                          fontWeight: 700,
                          fontSize: "13px",
                        }}
                      />
                    </td>

                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        type="text"
                        className="form-control text-center"
                        value={getRemedialLabel(row?.status_remed)}
                        disabled
                        readOnly
                        style={{
                          background:
                            row?.status_remed === true
                              ? "#fee2e2"
                              : "#f3f4f6",
                          color:
                            row?.status_remed === true
                              ? "#dc2626"
                              : "#6b7280",
                          border:
                            row?.status_remed === true
                              ? "1px solid #fca5a5"
                              : "1px solid #d1d5db",
                          fontWeight: 700,
                          fontSize: "13px",
                          cursor: "not-allowed",
                        }}
                      />
                    </td>

                    <td style={{ verticalAlign: "middle" }}>
                      <input
                        type="text"
                        className="form-control"
                        value={row?.komentar || ""}
                        disabled={savingScoreId === savingKey}
                        onChange={(e) =>
                          handleChangeNilai(
                            student.id,
                            tp.id,
                            "komentar",
                            e.target.value
                          )
                        }
                        onBlur={() => handleAutoSaveScore(student, tp)}
                        onKeyDown={(e) =>
                          handleInputKeyDown(e, student, tp)
                        }
                        style={{
                          fontSize: "13px",
                        }}
                      />
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={
                selectedTpList.length > 0
                  ? 2 + selectedTpList.length * 3
                  : 3
              }
              className="text-center p-4"
            >
              {selectedTpList.length === 0
                ? "TP belum tersedia"
                : "Data murid belum tersedia"}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</Col>
            </div>
          </Tab>
        </Tabs>
      </div>

      <style>
        {`
          .detail-label {
            font-size: 13px;
            color: #535353;
            font-weight: 700;
            margin-bottom: 7px;
          }

          .detail-value {
            font-size: 14px;
            font-weight: 700;
          }

          .text-primary {
            color: #006fb2 !important;
          }

          .text-success {
            color: #00a86b !important;
          }

          .text-danger {
            color: #ef4444 !important;
          }

          .body-table .form-control {
            height: 38px;
            border-radius: 7px;
          }

          .exam-score-table-wrap {
            overflow-x: auto;
          }

          .exam-score-table-wrap table {
            min-width: 900px;
          }

          .exam-loading-card {
            background: #ffffff;
            border-radius: 14px;
            padding: 18px;
            color: #404040;
            font-weight: 400;
            text-align: center;
          }

          .exam-hero-card {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 18px;
            background: linear-gradient(135deg, #ffffff 0%, #eef6ff 100%);
            border: 1px solid #e5edf7;
            border-radius: 18px;
            padding: 22px;
            box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
          }

          .exam-hero-title {
            color: #0f172a;
            font-size: 24px;
            font-weight: 800;
            margin: 0;
            text-transform: capitalize;
          }

          .exam-hero-meta {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #64748b;
            font-size: 14px;
            font-weight: 600;
            margin-top: 8px;
          }

          .exam-hero-right {
            min-width: 220px;
            text-align: right;
          }

          .exam-announce-date {
            margin-top: 8px;
            color: #64748b;
            font-size: 13px;
            font-weight: 600;
          }

          .exam-summary-grid {
            display: grid;
            grid-template-columns: repeat(6, minmax(0, 1fr));
            gap: 12px;
            margin-top: 16px;
          }

          .exam-mini-card {
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 16px;
            padding: 15px;
            min-height: 92px;
          }

          .exam-mini-label {
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
            text-transform: uppercase;
            margin-bottom: 12px;
          }

          .exam-mini-value {
            font-size: 14px;
            font-weight: 800;
          }

          .exam-main-panel,
          .exam-side-panel,
          .exam-schedule-panel {
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 18px;
            padding: 18px;
          }

          .exam-section-title {
            color: #0f172a;
            font-size: 15px;
            font-weight: 800;
            margin-bottom: 16px;
          }

          .exam-info-grid {
            display: grid;
            grid-template-columns: 1.4fr 1fr 1fr;
            gap: 14px;
          }

          .exam-info-card {
            background: #f8fafc;
            border: 1px solid #edf2f7;
            border-radius: 14px;
            padding: 15px;
          }

          .exam-info-label,
          .exam-side-label {
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
            text-transform: uppercase;
            margin-bottom: 7px;
          }

          .exam-info-value,
          .exam-side-value {
            color: #111827;
            font-size: 14px;
            font-weight: 800;
          }

          .exam-blue-text {
            color: #006fb2;
            font-weight: 800;
          }

          .exam-green-text {
            color: #00a86b;
            font-weight: 800;
          }

          .exam-muted-text {
            color: #6b7280;
            font-size: 13px;
            font-weight: 600;
          }

          .exam-tp-list {
            display: grid;
            gap: 10px;
          }

          .exam-tp-item {
            padding: 10px 12px;
            border-radius: 12px;
            background: #ffffff;
            border: 1px solid #e5e7eb;
          }

          .exam-schedule-panel {
            margin-top: 16px;
          }

          .exam-class-grid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 14px;
          }

          .exam-class-card {
            border-radius: 15px;
            padding: 16px;
            background: #f8fafc;
            border: 1px solid #e5e7eb;
          }

          .exam-class-name {
            color: #3f5bea;
            font-size: 15px;
            font-weight: 800;
            margin-bottom: 6px;
          }

          .exam-class-date {
            color: #111827;
            font-size: 14px;
            font-weight: 700;
          }

          @media (max-width: 1199px) {
            .exam-summary-grid {
              grid-template-columns: repeat(3, minmax(0, 1fr));
            }

            .exam-info-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 991px) {
            .exam-hero-card {
              flex-direction: column;
              align-items: flex-start;
            }

            .exam-hero-right {
              text-align: left;
              min-width: auto;
            }

            .exam-summary-grid {
              grid-template-columns: repeat(2, minmax(0, 1fr));
            }

            .exam-class-grid {
              grid-template-columns: 1fr;
            }
          }

          @media (max-width: 575px) {
            .exam-hero-title {
              font-size: 20px;
            }

            .exam-summary-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
    </div>
  );
}